export class TenantId {
  private constructor(private readonly value: number | string) {
    if (typeof value === 'number' && value <= 0) {
      throw new Error('Tenant ID must be greater than 0');
    }
    if (typeof value === 'string' && !value.trim()) {
      throw new Error('Tenant ID (GUID) cannot be empty');
    }
  }

  /**
   * Crea un nuevo TenantId con validaciones (soporta number o string/GUID)
   */
  static create(id: number | string): TenantId {
    return new TenantId(id);
  }

  /**
   * Reconstruye un TenantId desde persistencia (sin validaciones)
   */
  static fromValue(id: number | string): TenantId {
    const tenantId = Object.create(TenantId.prototype);
    (tenantId as any).value = id;
    return tenantId;
  }

  getValue(): number | string {
    return this.value;
  }

  equals(other: TenantId): boolean {
    return this.value === other.value;
  }

  isGuid(): boolean {
    return typeof this.value === 'string' && /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(this.value);
  }
}
